import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20webtoon%20style%20illustration%20of%20a%20dreamy%20fantasy%20cityscape%20with%20cherry%20blossom%20trees%2C%20floating%20pages%20of%20comic%20books%20in%20the%20air%2C%20warm%20sunset%20colors%20of%20coral%20pink%20and%20golden%20amber%2C%20whimsical%20and%20magical%20atmosphere%2C%20soft%20gradients%2C%20no%20text%2C%20no%20people%2C%20abstract%20artistic%20style&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
        alt="韩漫网 - 韩国漫画在线阅读平台"
        title="韩漫网 - 韩漫大全 下拉式韩国漫画在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 max-w-3xl leading-tight">
          韩漫大全，尽在<span className="text-primary-400">韩漫网</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
          整合海量韩国漫画资源，支持<strong>下拉式阅读</strong>和<strong>在线观看</strong>，无需跳转，为您提供一站式连贯流畅的韩漫阅读体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            立即开始阅读
            <span className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap text-sm border border-background-50/20"
          >
            热门推荐
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">10,000+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">500万+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">从不间断</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}